/**
 * RevealOnMount Hook
 *
 * Removes "invisible" class after one animation frame,
 * ensuring sibling hooks (e.g. PopoverSelect width sync) have completed.
 */
export const RevealOnMount = {
  mounted() {
    requestAnimationFrame(() => {
      this.el.classList.remove("invisible")
    })
  },

  updated() {
    this.el.classList.remove("invisible")
  },
}
